import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ADMIN_API } from "../../common/common";
import { Logout, formatNumberComma3dp } from "../../common/Funcation";
import { styleObjectBlackButton } from "../../common/StyleSeter";
import Pagination from "../../components/Pagination";
import SearchInput from "../../components/SearchInput";
import { notifyError, notifyMessage, postApi } from "../../service";
import SkyPopup from "../../components/SkyPopup";
import { usePagination } from "../../hooks/usePagination";
import Loader from "../../components/Loader";

interface playerInterface {
  agent_level: string;
  balance: number;
  credit_ref: number;
  exposure: number;
  firstName: string;
  lastName: string;
  ref_pl: number;
  remaining_balance: number;
  user_name: string;
  status?: string;
  cheatBlocked?: boolean;
  _id: string;
  formData: UpdateFormInterface;
}

function isLockedAccount(item: { status?: string; cheatBlocked?: boolean }) {
  return item?.status === "locked" || item?.cheatBlocked === true;
}
interface UpdateFormInterface {
  id: string;
  amount: any;
  credit_ref: any;
  Ttype: string;
  remark: string;
}

function PlayerBanking() {
  const navigate = useNavigate();
  const [pageData, setPageData] = useState<any>({});
  const [password, setPassword] = useState<string>("");
  const [isSubmitted, setIsSubmitted] = useState(false);
  const submitLockRef = useRef(false);
  const dispatch = useDispatch();
  const DD = useSelector((e: any) => e.domainDetails);
  const [isHover, setIsHover] = useState(false);
  const [editedIds, setEditedIds] = useState<any>([]);
  const handleMouseEnter = () => {
    setIsHover(true);
  };
  const handleMouseLeave = () => {
    setIsHover(false);
  };
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [accountStatus, setAccountStatus] = useState<string>("active");
  const [OpenModal, setOpenModal] = useState<boolean>(false);
  const limit = 100;
  const [totalPages, setTotalPages] = useState(0);
  const [listLoading, setListLoading] = useState(false);
  const listRequestRef = useRef(0);

  const {
    currentPage: paginationPage,
    setCurrent: setPaginationPage,
    visiblePages,
    handlePageClick,
  } = usePagination({
    totalPages: totalPages,
    currentPage: 1,
    onPageChange: (page) => {
      getPageData("player", page.toString(), searchTerm, accountStatus);
      setPaginationPage(page);
    },
  });

  useEffect(() => {
    getPageData("player", "1");
    return () => {};
  }, []);

  const getPageData = async (
    TYPE: string,
    PAGE: string,
    search: string = "",
    status: string = "active",
  ) => {
    const requestId = ++listRequestRef.current;
    setListLoading(true);
    let data: any = {
      api: ADMIN_API.BANKING.GET_LIST,
      value: {
        type: TYPE,
        page: PAGE ? PAGE : "1",
        limit: limit.toString(),
      },
    };
    if (search !== "") {
      data.value.search = search;
    }
    if (status && status !== "active") {
      data.value.status = status;
    }
    try {
      const response = await postApi(data);
      if (requestId !== listRequestRef.current) return;
      const results = response.data?.data?.player?.results;
      if (Array.isArray(results)) {
        results.forEach((element: playerInterface) => {
          element.formData = {
            id: element._id,
            amount: "",
            credit_ref: element.credit_ref,
            Ttype: "",
            remark: "",
          };
        });
      }
      setPageData(response.data?.data);
      dispatch({
        type: "UPDATE_BALANCE",
        payload: response.data?.data?.remaining_balance,
      });
      setTotalPages(response.data?.data?.player?.totalPages || 0);
    } catch (err: any) {
      if (requestId !== listRequestRef.current) return;
      if (err?.response?.data?.statusCode === 401) {
        Logout();
        navigate("/login");
      }
    } finally {
      if (requestId === listRequestRef.current) {
        setListLoading(false);
      }
    }
  };

  const releaseSubmit = () => {
    submitLockRef.current = false;
    setIsSubmitted(false);
  };

  const updatePageData = async (DATA: any) => {
    let dataCopy = { ...DATA };

    let newDate = DATA.usersData.filter(
      (_: any) => _.amount !== 0 && _.amount !== "",
    );
    dataCopy.usersData = newDate;
    if (dataCopy.usersData.length === 0) {
      notifyMessage("there is noting update");
      releaseSubmit();
      return;
    }
    let data = {
      api: ADMIN_API.BANKING.UPDATE,
      value: dataCopy,
    };
    try {
      await postApi(data);
      setPaginationPage(1);
      setPassword("");
      setEditedIds([]);
      if (searchTerm !== "") {
        await getPageData("player", "1", searchTerm, accountStatus);
      } else {
        await getPageData("player", "1", "", accountStatus);
      }
      notifyMessage("Executed Successfully");
    } catch (err: any) {
      setPassword("");
      notifyError(err?.response?.data?.message);
      if (err?.response?.data?.statusCode === 401) {
        Logout();
        navigate("/login");
      }
    } finally {
      releaseSubmit();
    }
  };

  const handleInputChange = (
    e: HTMLInputElement | any,
    item: playerInterface,
  ) => {
    if (isLockedAccount(item)) return;
    let { value, name } = e.target;
    if (name === "amount" || name === "credit_ref") value = Number(value);
    let CopyPageData = JSON.parse(JSON.stringify(pageData));
    CopyPageData.player?.results.forEach((element: playerInterface) => {
      if (element._id === item._id) {
        element.formData = {
          ...element.formData,
          id: element._id,
          [name]: value,
        };
        if (name === "fullBtn") {
          element.formData = {
            ...element.formData,
            amount: element.balance != null ? element.balance :  element.remaining_balance,
          };
        }
        
        if (name === "Ttype") {
          element.formData = {
            ...element.formData,
            id: element._id,
            [name]: value,
            remark: value === "deposit" ? "Deposit" : "Withdraw",
          };
        }
        let ids = [...editedIds];
        if (!ids?.includes(item._id)) {
          ids.push(item._id);
        }
        setEditedIds(ids);
      }
    });

    setPageData(CopyPageData);
  };
  const handlePassword = (e: any) => {
    setPassword(e.target.value);
  };
  const handleSubmit = (e: any) => {
    e.preventDefault();
    if (submitLockRef.current) return;
    submitLockRef.current = true;
    setIsSubmitted(true);
    let userData: any = [];
    pageData.player?.results.forEach((element: playerInterface) => {
      if (isLockedAccount(element)) return;
      userData.push(element.formData);
    });
    let data = {
      type: "player",
      password: password,
      usersData: userData,
    };

    updatePageData(data);
  };
  const handleSearchSubmit = (search: any) => {
    setSearchTerm(search);
    setPaginationPage(1);
    getPageData("player", "1", search, accountStatus);
  };
  return (
    <>
      {listLoading && <Loader />}
      <div
        className="container banking player full-wrap"
        style={{ height: "calc(100vh - 106px)", overflowY: "hidden" }}
      >
        <h2>Banking</h2>
        <div className="top_header mt-3">
          <SearchInput
            searchSubmit={handleSearchSubmit}
            design="in"
            placeholder="Enter userId..."
          />
          <ul
            style={{
              display: "flex",
              marginLeft: "20px",
              alignItems: "center",
              gap: "5px",
            }}
          >
            <li>
              <strong>Status</strong>
            </li>
            <li>
              <select
                style={{ margin: 0, height: "32px" }}
                name="accountStatus"
                id="accountStatus"
                value={accountStatus}
                onChange={(e) => {
                  const next = e.target.value;
                  setAccountStatus(next);
                  setPaginationPage(1);
                  setEditedIds([]);
                  getPageData("player", "1", searchTerm, next);
                }}
              >
                <option value="active">ACTIVE</option>
                <option value="suspend">SUSPENDED</option>
                <option value="locked">LOCKED</option>
                <option value="all">ALL</option>
              </select>
            </li>
          </ul>
        </div>
        <div
          className="report_over-wrap"
          style={{ maxHeight: "calc(100% - 208px)", overflow: "auto" }}
        >
          <div className="banking_content">
            <div className="banking_content_table">
              <div className="function-wrap">
                {/* <strong className="text-primary">Agent Banking</strong> */}
                <span
                  className="banking-head"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <strong
                    className="pr-1"
                    style={{
                      fontSize: "13px",
                      fontWeight: "bold",
                      color: "#3b5160",
                    }}
                  >
                    Your Balance
                  </strong>
                  <div
                    className="border-left-content"
                    style={{ borderLeft: "1px solid #7e97a7" }}
                  >
                    <span
                      className="pr-0-5"
                      style={{
                        fontSize: "13px",
                        fontWeight: "normal",
                        color: "#3b5160",
                      }}
                    >
                      {DD?.currency ? DD?.currency : "PTH"}
                    </span>
                    <span className="h5">
                      <strong>
                        {formatNumberComma3dp(pageData?.remaining_balance)}
                      </strong>
                    </span>
                  </div>
                </span>
              </div>
              <div className="table-responsive">
                  <table
                    id="resultTable"
                    className="tab-transfer tab-banking table01 margin-table"
                    style={{ tableLayout: "fixed" }}
                  >
                    <colgroup>
                      <col span={1} width="190" />
                      <col
                        span={1}
                        width="120"
                        style={{ display: "none" }}
                        id="siteColumn"
                      />
                      <col
                        span={1}
                        width="120"
                        style={{ display: "none" }}
                        id="currencyTypeColumn"
                      />
                      <col span={1} width="120" />
                      <col span={1} width="120" />
                      <col span={1} width="120" />

                      <col span={1} width="275" />
                    </colgroup>
                    <thead>
                      <tr>
                        <th style={{ textAlign: "left" }}>
                          {" "}
                          UID{" "}
                          <span
                            style={{
                              fontSize: "9px",
                              marginLeft: "0px",
                              display: "inline-block",
                              verticalAlign: "middle",
                            }}
                          >
                            ▼
                          </span>
                        </th>
                        <th style={{ textAlign: "right" }}> Balance</th>
                        <th style={{ textAlign: "right" }}> Available D/W </th>
                        <th style={{ textAlign: "right" }}> Exposure </th>
                        <th
                          style={{ textAlign: "center" }}
                          className="bordered"
                        >
                          {" "}
                          Deposit / Withdraw{" "}
                        </th>
                        <th style={{ textAlign: "right" }} className="bordered">
                          {" "}
                          Credit Reference{" "}
                        </th>
                        <th style={{ textAlign: "right" }}>Reference P/L</th>
                        <th
                          style={{ textAlign: "right" }}
                          className="bordered"
                        >
                          {" "}
                          Remark{" "}
                        </th>
                        <th
                          style={{ width: "7%", textAlign: "left" }}
                          className="bordered"
                        >
                          {" "}
                          Logs{" "}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {listLoading ? (
                        <></>
                      ) : pageData.player?.results &&
                      pageData.player?.results.length > 0 ? (
                        pageData.player?.results.map(
                          (item: playerInterface, i: any) => {
                            const locked = isLockedAccount(item);
                            return (
                              <>
                                <tr key={item._id}>
                                  <td>
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      <span
                                        style={{
                                          width: "24px",
                                          textAlign: "center",
                                          marginRight: "10px",
                                          color: "#888",
                                          display: "inline-block",
                                          flexShrink: 0,
                                        }}
                                      >
                                        {i + 1}
                                      </span>
                                      <span style={{ color: "#1e1e1e" }}>
                                        {item.user_name}
                                      </span>
                                      {(item.cheatBlocked ||
                                        (item.status && item.status !== "active")) && (
                                        <span
                                          style={{
                                            marginLeft: "8px",
                                            fontSize: "10px",
                                            fontWeight: 700,
                                            color: locked
                                              ? "#c0392b"
                                              : "#b8860b",
                                          }}
                                        >
                                          {locked ? "LOCKED" : "SUSPENDED"}
                                        </span>
                                      )}
                                    </div>
                                  </td>
                                  <td align="right">
                                    {formatNumberComma3dp(
                                      item.remaining_balance,
                                    )}
                                  </td>
                                  <td align="right">
                                    {formatNumberComma3dp(item?.balance)}
                                  </td>
                                  <td align="right" className="text-danger">
                                    {formatNumberComma3dp(item.exposure)}
                                  </td>
                                  <td className="bordered">
                                    <div className="dw_wrp">
                                      <div className="dw_wrp_dw">
                                        <div
                                          className="btn-group credit-type"
                                          role="group"
                                          aria-label="Basic radio toggle button group"
                                        >
                                          <input
                                            type="checkbox"
                                            className="btn-check"
                                            name="Ttype"
                                            id={"d" + item._id}
                                            value="deposit"
                                            disabled={locked}
                                            onChange={(e) =>
                                              handleInputChange(e, item)
                                            }
                                            checked={
                                              item.formData.Ttype === "deposit"
                                            }
                                          />
                                          <label
                                            style={{
                                              marginRight: "0px",
                                              marginBottom: "0px",
                                              backgroundColor: "#ffb80c",
                                            }}
                                            className="btn btn-outline-primary shadow-none"
                                            htmlFor={"d" + item._id}
                                          >
                                            D
                                          </label>
                                          <input
                                            type="checkbox"
                                            className="btn-check"
                                            name="Ttype"
                                            id={"w" + item._id}
                                            value="withdraw"
                                            disabled={locked}
                                            onChange={(e) =>
                                              handleInputChange(e, item)
                                            }
                                            checked={
                                              item.formData.Ttype === "withdraw"
                                            }
                                          />
                                          <label
                                            style={{
                                              marginBottom: "0px",
                                              backgroundColor: "#ffb80c",
                                              marginRight: "6px"
                                            }}
                                            className="btn btn-outline-danger shadow-none"
                                            htmlFor={"w" + item._id}
                                          >
                                            W
                                          </label>
                                        </div>
                                      </div>
                                      <div style={{ position: "relative" }}>
                                        <input
                                          type="number"
                                          name="amount"
                                          disabled={
                                            locked ||
                                            (item.formData.Ttype === "deposit" ||
                                            item.formData.Ttype === "withdraw"
                                              ? false
                                              : true)
                                          }
                                          onChange={(e) => {
                                            if (
                                              item.formData.Ttype ===
                                                "deposit" ||
                                              item.formData.Ttype === "withdraw"
                                            ) {
                                              handleInputChange(e, item);
                                            }
                                          }}
                                          value={item?.formData?.amount}
                                          className="form-control"
                                          placeholder="0"
                                          style={{
                                            width: "130px",
                                            height: "30px",
                                            textAlign: "right",
                                            paddingRight: "5px",
                                            fontSize: "12px",
                                            fontWeight: 700,
                                            color:
                                              item?.formData?.Ttype ===
                                              "withdraw"
                                                ? "#ff0000"
                                                : item?.formData?.Ttype ===
                                                    "deposit"
                                                  ? "#000"
                                                  : "inherit",
                                          }}
                                        />
                                        <span
                                          style={{
                                            position: "absolute",
                                            left: "0",
                                            top: "0",
                                            height: "100%",
                                            display: "flex",
                                            alignItems: "center",
                                            padding: "0 10px",
                                            fontSize: "15px",
                                            fontWeight: 800,
                                            color:
                                              item?.formData?.Ttype ===
                                              "withdraw"
                                                ? "#ff0000"
                                                : item?.formData?.Ttype ===
                                                    "deposit"
                                                  ? "#5bab03"
                                                  : "inherit",
                                          }}
                                        >
                                          {item?.formData?.Ttype === "withdraw"
                                            ? "-"
                                            : item?.formData?.Ttype ===
                                                "deposit"
                                              ? "+"
                                              : ""}
                                        </span>
                                      </div>
                                      <div className="dw_wrp_am">
                                        {/* <span style={{ color: `${item.formData.Ttype === 'deposit' ? "#38b338" : "#ff0000"}` }}> {item.formData.Ttype === 'deposit' ? "+" : "-"}</span> */}
                                      </div>
                                      <button
                                        onClick={(e) =>
                                          handleInputChange(e, item)
                                        }
                                        name="fullBtn"
                                        disabled={
                                          locked ||
                                          (item.formData.Ttype === "withdraw"
                                            ? false
                                            : true)
                                        }
                                        style={{
                                          backgroundColor: "#ffb80c",
                                          color: "#000",
                                          fontWeight: 600,
                                          marginLeft: "6px",
                                        }}
                                        className={`full ${item.formData.Ttype === "withdraw" ? "" : "not-allow"}`}
                                      >
                                        {" "}
                                        Full{" "}
                                      </button>
                                    </div>
                                  </td>
                                  <td className="bordered">
                                    {/* <input type="number" style={{ width: "100px" }} name="credit_ref" onChange={(e) => handleInputChange(e, item)} value={item?.formData?.credit_ref} step="0.01" className="form-control" /> */}
                                    <div
                                      style={{
                                        display: "flex",
                                        flexWrap: "wrap",
                                        justifyContent: "end",
                                        alignItems: "center",
                                      }}
                                    >
                                      {/* <input type="number" style={{ width: "100px", marginRight: "5px" }} name="credit_ref" onChange={(e) => handleInputChange(e, item)} value={item?.formData?.credit_ref ? item?.formData?.credit_ref : ''} step="0.01" className="form-control" placeholder="Credit Ref" /> */}
                                      <u
                                        className="text-blue"
                                        style={{ marginRight: "10px" }}
                                      >
                                        {" "}
                                        {formatNumberComma3dp(
                                          item?.formData?.credit_ref,
                                        )}
                                      </u>
                                      <button
                                        className="credit_ref_eidt"
                                        onClick={() => setOpenModal(true)}
                                        style={{ fontFamily: "Tahoma" }}
                                      >
                                        {" "}
                                        Edit{" "}
                                      </button>
                                    </div>
                                  </td>
                                  <td align="right" className={item?.formData?.credit_ref > item?.balance ? "text-danger" : ""}>
                                    {item?.formData?.credit_ref > item?.balance
                                      ? `(${formatNumberComma3dp(item.ref_pl)})`
                                      : formatNumberComma3dp(item.ref_pl)}
                                  </td>
                                  <td className="bordered" align="right">
                                    <input
                                      type="text"
                                      style={{ fontWeight: "normal", fontSize: "12px" }}
                                      placeholder="Remark"
                                      name="remark"
                                      className="form-control remark"
                                      onChange={(e) =>
                                        handleInputChange(e, item)
                                      }
                                      value={item?.formData?.remark}
                                      disabled={locked}
                                      readOnly
                                      onFocus={(e) => e.target.removeAttribute('readOnly')}
                                      onBlur={(e) => e.target.setAttribute('readOnly', 'true')}
                                      autoComplete="off"
                                    />
                                  </td>
                                  <td align="right" className="bordered">
                                    <button
                                      type="button"
                                      className="log"
                                      onClick={() =>
                                        navigate(
                                          `/user/transaction-history/player/${item._id}/`,
                                        )
                                      }
                                      style={{ fontFamily: "Tahoma" }}
                                    >
                                      {" "}
                                      Log{" "}
                                    </button>
                                  </td>
                                </tr>
                              </>
                            );
                          },
                        )
                      ) : !listLoading && pageData.player?.results?.length === 0 && (
                        <h3>NO DATA</h3>
                      )}
                    </tbody>
                  </table>
              </div>
              {!listLoading && totalPages > 0 && pageData.player?.results?.length > 0 && (
                <Pagination
                  currentPage={paginationPage}
                  totalPages={totalPages}
                  visiblePages={visiblePages}
                  handlePageClick={handlePageClick}
                />
              )}
            </div>
          </div>
        </div>

        <div className="banking_content_footer submit-wrap">
          <ul>
            <li className="clearAll">
              <button
                style={{ backgroundColor: "#ffb80c", color: "#1e1e1e" }}
                onClick={() => {
                  setPaginationPage(1);
                  if (searchTerm !== "") {
                    getPageData("player", "1", searchTerm, accountStatus);
                  } else {
                    getPageData("player", "1", "", accountStatus);
                  }
                  setEditedIds([]);
                }}
              >
                {" "}
                Clear All
              </button>
            </li>
            <li className="pass">
              <div className="input-group">
                <input
                  type="password"
                  onChange={(e) => handlePassword(e)}
                  value={password}
                  className="form-control"
                  placeholder="Password"
                  name="txn_confirm_password"
                  autoComplete="new-password"
                  data-lpignore="true"
                />
                <button
                  style={{
                    backgroundColor: "#ffb80c",
                    color: "#1e1e1e",
                    margin: 0,
                    border: "1px solid #1e1e1e",
                    fontWeight: "700 !important",
                    fontSize: "13px",
                  }}
                  className="btn"
                  type="button"
                  id="basic-addon2"
                  disabled={isSubmitted}
                  onClick={(e) => handleSubmit(e)}
                >
                  {isSubmitted ? (
                    "Please wait"
                  ) : (
                    <>
                      Submit <span className="count">{editedIds?.length}</span>{" "}
                      Payment
                    </>
                  )}
                </button>
              </div>
            </li>
          </ul>
        </div>
      </div>
      {OpenModal && (
        <SkyPopup
          title={`Credit Reference Edit`}
          customClass="credit-edit"
          OpenModal={OpenModal}
          closeModel={() => setOpenModal(false)}
          maxWidth={380}
        >
          <div>
            <input type="hidden" name="_token" />
            <input type="hidden" name="user_id" id="user_id" value="133" />
            <div className="modal-body">
              <div className="d_flex">
                <div className="fieldset full new">
                  <div className="mb-2 flex-align content-between">
                    <span className="currenet flex-align">
                      Current <strong>800000</strong>
                    </span>
                    <button
                      className="log"
                      style={styleObjectBlackButton(DD?.colorSchema, true)}
                    >
                      {" "}
                      Log{" "}
                    </button>
                  </div>
                </div>
                <div className="fieldset full new">
                  <div className="mb-2 flex-align content-between">
                    <span>New</span>
                    <span style={{ width: "70%" }}>
                      <input
                        type="number"
                        name="credit_ref"
                        maxLength={16}
                        className="form-control"
                      />
                    </span>
                  </div>
                </div>
                <div className="fieldset full new">
                  <div className="mb-2 flex-align content-between">
                    <span> Password </span>
                    <span style={{ width: "70%" }}>
                      <input
                        type="password"
                        name="password"
                        className="form-control"
                        autoComplete="new-password"
                        data-lpignore="true"
                      />
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </SkyPopup>
      )}
    </>
  );
}

export default PlayerBanking;
